import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=1881f1be&functional=true"
var script = {}
import style0 from "./Empty.vue?vue&type=style&index=0&id=1881f1be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports